import React from 'react'
import ins1 from "../../assets/ins1.webp"
import ins2 from "../../assets/ins2.webp"
import ins3 from "../../assets/ins3.webp"
import ins4 from "../../assets/ins4.webp"
import ins5 from "../../assets/ins5.webp"

const DigitalExperience = () => {
    const inspiration = [
        {
            id: 1,
            title: "Rachel Chinonouri",
            description: "Fans were invited to share their personal stories of what Chinouriri's music means to them and have these voice notes added to the core album track listing. This release was the perfect articulation of what fans can only dream of; acknowledgement from their favourite artist and inclusion in the creative process.",
            img: ins1,
        },
        {
            id: 2,
            title: "Thirty Seconds to Mars",
            description: "This limited edition Digital Experiences of the Leto brothers’ 6th album was the only place to hear Jared Leto talk through the inspiration and creative process behind each track. While this track by track was produced for US syndicated radio, this digital pressing was the only way to own it.",
            img: ins2,
        },
        {
            id: 3,
            title: "Bugzy Malone",
            description: "Manchester rap star and ‘King of the North’, Bugzy Malone, shared an exclusive in depth interview about his 3rd album, ‘The Great British Dream’, that is only available to owners of this limited edition digital pressing. Also included, exclusive behind-the-scenes footage from the photo shoot for Bugzy’s new fragrance, House of Vision.",
            img: ins3,
        },
        {
            id: 4,
            title: "Orbital",
            description: "Orbital fans love instrumentals from their favourite electronic legends and this version of the album was the only place to source them. The Hartnoll brothers also included exclusive animated artwork and an interview about the record not available elsewhere.",
            img: ins4,
        },
        {
            id: 5,
            title: "The Hives",
            description: "Iconic rock n roll band, The Hives, celebrated the release of their first record in 10 years with Serenade by including a bonus album of live greatest hits from their recent show at the Emirates Stadium, London. Plus some voice notes from each member of the band.",
            img: ins5,
        },
    ]
    return (
        <div className='digital-experience py-[50px]'>
            <div className="container mx-auto">
                {/* breadcrumb */}
                <div className="breadcrumb rounded-xl digital-bradcrumb relative py-[60px] px-[25px] lg:px-[50px]">
                    <h1 className="text-center text-white text-[40px] lg:text-[60px] font-bold">
                        What to include in your Digital Experience
                    </h1>
                </div>
                {/* breadcrumb */}
            </div>


            <div className="container mt-[50px] mx-auto">
                {/* contents */}
                <div className="">
                    <div className="text-center">
                        <p className="text-lg font-bold">
                            Digital Experiences are the digital albums, EPs and singles that get unlocked through Smart <br /> Formats.  Alongside music, artists can pack their Digital Experiences full of bonus content like <br /> photos, videos and audio tracks, and update them as often as they like.
                        </p>
                    </div>


                    <div className="mt-[50px]">
                        <div className="text-center">
                            <h2 className='text-[40px] font-bold'>
                                Some <span className='besley font-normal italic'>inspiration</span>
                            </h2>
                            <p className="mt-6 text-lg">
                                We’ve seen a lot of brilliant Digital Exepreinces pass through Serenade <br /> over the years and have listed some of our favourites below:
                            </p>
                        </div>

                        <div className="mt-[100px]">
                            {
                                inspiration.map(ins => (
                                    <div key={ins.id} className={`flex lg:mt-0 mt-6 lg:flex-row flex-col ${ins.id % 2 === 0 && 'even'} justify-between items-center gap-0`}>
                                        <div className="left w-full lg:w-[50%]">
                                            <img src={ins.img} className='w-full' alt="" />
                                        </div>
                                        <div className="right w-full lg:w-[50%] lg:p-20 pt-10">
                                            <h3 className='text-[30px] font-semibold'>{ins.title}</h3>
                                            <p className='text-lg mt-4'>{ins.description}</p>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
                {/* contents */}
            </div>
        </div >
    )
}

export default DigitalExperience